import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import ElementPlus from 'element-plus'; // 引入 Element Plus 库
import zhCn from 'element-plus/dist/locale/zh-cn.mjs';
import 'element-plus/dist/index.css'; // 引入 Element Plus 样式

const app = createApp(App);
app.use(router);
app.use(ElementPlus, {
  locale: {
    ...zhCn,
    el: {
      ...zhCn.el,
      pagination: {
        ...zhCn.el.pagination,
        total: '共计 {total}',
        pageClassifier: '页',
        goto: '到',
      },
    },
  },
});
app.mount('#app');

// 抑制 ResizeObserver loop 未投递通知警告（来自 el-table 等组件渲染，无实际影响）
window.addEventListener('error', (event) => {
  if (event.message && event.message.includes('ResizeObserver loop')) {
    event.stopPropagation();
    event.stopImmediatePropagation();
    event.preventDefault();
    return true;
  }
}, true);
